export var buildSearchMetadata = function buildSearchMetadata(searchTerm) {
  if (!searchTerm || searchTerm.trim().length === 0) {
    return {
      title: '',
      description: ''
    };
  }
  var title = "Immobilienmakler ".concat(searchTerm, " | Makler bei ImmoScout24");
  var description = "".concat(searchTerm, ": Bei ImmoScout24 finden Sie passende Immobilienmakler in ").concat(searchTerm, " ") + "f\xFCr den Verkauf und die Vermietung. \u2713 Kompetent \u2713 seri\xF6s \u2713 online kontaktieren!";
  return {
    title: title,
    description: description
  };
};